import BoolField from './component';

export default BoolField;
